
shadow.loader.set_load_start('bulletins');